export default {
    name: "SettingsUserManagementHeader",

    props: {
        users_count: {
            type: Number,
            default: 0
        },
        active_users_count: {
            type: Number,
            default: 0
        }
    },

    emits: ["open-add-user"],

    computed: {
        inactive_users_count() {
            return Math.max(this.users_count - this.active_users_count, 0);
        }
    }
};
